import { lazyModal } from '@/lib/lazy-load'

export const UploadBar = lazyModal(() => import('./UploadBar'))
export const UploadErrorModal = lazyModal(() => import('./UploadErrorModal'))
